import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { UrlValidatorService } from '../../core/services/url-validator.service';

@Injectable()
export class OperationalCertificateService {

     baseUrl: string = environment.API_URL;
        serviceBase = this.baseUrl + '/api/zeroCarbonCertificate';

    constructor(private http: HttpClient, private urlValidator: UrlValidatorService) { }

    getStaticText(selectedLanguage: string) {
        const sanitizedSelectedLanguage = this.urlValidator.sanitizeParam(selectedLanguage);
        const params = new HttpParams().set('selectedLanguage', sanitizedSelectedLanguage);
        return this.http.get(this.baseUrl + '/api/projectCertificate/staticText', { params });
    }

    getAllCertificates(projectId:any, stageName:string) {
        const sanitizedProjectId = this.urlValidator.sanitizeParam(projectId);
        const sanitizedStageName = this.urlValidator.sanitizeParam(stageName);
        const params = new HttpParams()
            .set('projectId', sanitizedProjectId)
            .set('stageName', sanitizedStageName);
        return this.http.get(this.serviceBase + '/getZeroCarbonCertificates', { params });
    }

    previewZCCertificate(projectId: string, stageName: string, selectedLanguage: string): Observable<any> {
        const sanitizedProjectId = this.urlValidator.sanitizeParam(projectId);
        const sanitizedStageName = this.urlValidator.sanitizeParam(stageName);
        const sanitizedSelectedLanguage = this.urlValidator.sanitizeParam(selectedLanguage);
        const params = new HttpParams()
            .set('projectId', sanitizedProjectId)
            .set('stageName', sanitizedStageName)
            .set('selectedLanguage', sanitizedSelectedLanguage);
        return this.http.post<any>(this.serviceBase + '/getZeroCarbonCertificatePreview', null, { params });
    }

    generateZCCertificateTrigger(projectId: string, stageName: string, tempCertFile: string, selectedLanguage: string): Observable<any> {
        const sanitizedProjectId = this.urlValidator.sanitizeParam(projectId);
        const sanitizedStageName = this.urlValidator.sanitizeParam(stageName);
        const sanitizedTempCertFile = this.urlValidator.sanitizeParam(tempCertFile);
        const sanitizedSelectedLanguage = this.urlValidator.sanitizeParam(selectedLanguage);
        const params = new HttpParams()
            .set('projectId', sanitizedProjectId)
            .set('stageName', sanitizedStageName)
            .set('tempCertFile', sanitizedTempCertFile)
            .set('selectedLanguage', sanitizedSelectedLanguage);
        return this.http.post<any>(this.serviceBase + '/generateZeroCarbonCertificate', null, { params });
    }

    getZCProjectCertificateData(projectId: string, stageName: string) {
        const sanitizedProjectId = this.urlValidator.sanitizeParam(projectId);
        const sanitizedStageName = this.urlValidator.sanitizeParam(stageName);
        const params = new HttpParams()
            .set('projectID', sanitizedProjectId)
            .set('stageName', sanitizedStageName);
        return this.http.get(this.serviceBase + '/getZeroCarbonCertificateData', { params });
    }

    getExcelTemplate() {
        const queryString = this.baseUrl + '/api/Reports/getExcelTemplate';
        return this.http.get(queryString);
    }

    downloadSupportKit(projectDetailId: string) {
        const sanitizedProjectDetailId = this.urlValidator.sanitizeParam(projectDetailId);
        const params = new HttpParams().set('projectDetailId', sanitizedProjectDetailId);
        return this.http.get(this.baseUrl + '/api/projectCertificate/downloadSupportKit', { params, observe: 'response', responseType: 'blob' })
            .pipe(
                map(results => {
                    return { data: results.body, fileName: results.headers.get('fileName') };
                })
            );
    }

    downloadSelectedCertificate(projectCertificateSelectedFileId: any,stageName:string) {
        const sanitizedStageName = this.urlValidator.sanitizeParam(stageName);
        const params = new HttpParams().set('stageName', sanitizedStageName);
        return this.http.post(this.serviceBase + '/downloadSelectedZeroCarbonCertificate', projectCertificateSelectedFileId, { params, responseType: 'blob', observe: 'events', reportProgress: true });
    }

    downloadAllCertificate(projectId: any, stageName : string) {
        const sanitizedProjectId = this.urlValidator.sanitizeParam(projectId);
        const sanitizedStageName = this.urlValidator.sanitizeParam(stageName);
        const params = new HttpParams()
            .set('projectID', sanitizedProjectId)
            .set('stageName', sanitizedStageName);
        return this.http.get(this.serviceBase + '/downloadAllZeroCarbonCertificate', { params, responseType: 'blob', observe: 'events', reportProgress: true });
    }

    downloadGeneralInstructions(projectDetailId: string) {
        const sanitizedProjectDetailId = this.urlValidator.sanitizeParam(projectDetailId);
        const params = new HttpParams().set('projectDetailId', sanitizedProjectDetailId);
        return this.http.get(this.baseUrl + '/api/projectCertificate/downloadGeneralInstructions', { params, observe: 'response', responseType: 'blob' })
            .pipe(
                map(results => {
                    return { data: results.body, fileName: results.headers.get('fileName') };
                })
            );
    }

    downloadUploadedFile(fileUploadHistoryId: string) {
        const queryString = this.baseUrl + '/api/projectCertificate/downloadUnitsUploadedFile?fileUploadHistoryId=' + fileUploadHistoryId;
        return this.http.get(queryString, { observe: 'response', responseType: 'blob' })
            .pipe(
                map(results => {
                    return { data: results.body, fileName: results.headers.get('fileName') };
                })
            );
    }

    saveZCProjectCertificateDetails(certificateData: any) {
        const queryString = '/saveZeroCarbonCertificateDetails';
        return this.http.post(this.serviceBase + queryString, certificateData);
    }
}
